// extracted by mini-css-extract-plugin
module.exports = {"filterWrapper":"styles_filterWrapper__3ehKT","filterBox":"styles_filterBox__1AgQj","filterInput":"styles_filterInput__3xU23"};